import { castArray, isNil } from 'lodash-es';
import { useMemo } from 'react';

import services from 'services';
import { NavigationArea } from 'types';
import { isAvailable } from 'utils';

import useCollectionServices from './useCollectionServices';

const useProfileMenuItems = (navigationArea: NavigationArea) => {
  const items = useCollectionServices(services.appFrame.profileMenu);

  return useMemo(
    () =>
      items.filter(
        ({ navigation, available }) =>
          isAvailable(available ?? true) && (isNil(navigation) || castArray(navigation).includes(navigationArea)),
      ),
    [items, navigationArea],
  );
};

export default useProfileMenuItems;
